import React, { useRef, useState } from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useStateValue } from '@State'
import { payments as endpoints } from '@URLS'
import { client } from '@Utils'
import { toast } from '@CommonComponents/toast'

const UploadForm = () => {
  const [currentState, dispatch] = useStateValue()
  const [previewing, setPreviewing] = useState(false)
  const fileInputRef = useRef(null)

  const handlePreview = async () => {
    if (!currentState.csvFile) {
      toast.error('Please select a CSV file.')
      return
    }
    if (!currentState.description) {
      toast.error('Please enter a description.')
      return
    }
    setPreviewing(true)
    const formData = new FormData()
    formData.append('csv_file', currentState.csvFile)
    formData.append('description', currentState.description)
    formData.append('source', currentState.source)
    formData.append('invoice_number', currentState.invoiceNumber)
    try {
      const resp = await client.post(endpoints.previewBatch, formData)
      dispatch({ type: 'updatePreviewRows', previewRows: resp.data.rows })
    } catch (err) {
      toast.error(
        (err.response && err.response.data && err.response.data.error) ||
          'Error previewing batch.'
      )
    } finally {
      setPreviewing(false)
    }
  }

  return (
    <div className="card-myed p-3 mb-4">
      <Row>
        <Col md={4}>
          <Form.Group>
            <Form.Label>CSV File</Form.Label>
            <Form.Control
              type="file"
              accept=".csv"
              ref={fileInputRef}
              onChange={e =>
                dispatch({ type: 'updateCsvFile', csvFile: e.target.files[0] || null })
              }
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              value={currentState.description}
              onChange={e =>
                dispatch({ type: 'updateDescription', description: e.target.value })
              }
              placeholder="e.g. University of Phoenix — May 2026"
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Source</Form.Label>
            <Form.Control
              as="select"
              value={currentState.source}
              onChange={e =>
                dispatch({ type: 'updateSource', source: e.target.value })
              }
            >
              <option value="">Select...</option>
              <option value="ACH">ACH</option>
              <option value="Credit Card">Credit Card</option>
              <option value="Check">Check</option>
              <option value="Paypal">Paypal</option>
              <option value="Wire">Wire</option>
              <option value="Other">Other</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Invoice #</Form.Label>
            <Form.Control
              type="text"
              value={currentState.invoiceNumber}
              onChange={e =>
                dispatch({ type: 'updateInvoiceNumber', invoiceNumber: e.target.value })
              }
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="text-right">
        <Button
          variant="primary"
          className="btn-myed btn-primary-myed"
          onClick={handlePreview}
          disabled={previewing}
        >
          <span
            className={
              previewing
                ? 'far fa-spinner fa-spin fa-fw mr-2'
                : 'far fa-eye fa-fw mr-2'
            }
          />
          Preview
        </Button>
      </div>
    </div>
  )
}

export default UploadForm
